// 获取全部缓存
const objDictCity = () => {
  return JSON.parse(localStorage.getItem("DictCity"));
};
const objUserClient = () => {
  return JSON.parse(localStorage.getItem("UserClient"));
};
const objAccount = () => {
  return JSON.parse(localStorage.getItem("Account"));
};
const objDriverstatus = () => {
  return JSON.parse(localStorage.getItem("DictDriverstatus"));
};
const objCurrency = () => {
  return JSON.parse(localStorage.getItem("Currency"));
};

let objException = () => {
  return JSON.parse(localStorage.getItem("Exception"));
};
let objDictRole = () => {
  return JSON.parse(localStorage.getItem("DictRole"));
};
let objPackage = () => {
  return JSON.parse(localStorage.getItem("Package"));
};
let objAirport = () => {
  return JSON.parse(localStorage.getItem("Airport"));
};
let objContraband = () => {
  return JSON.parse(localStorage.getItem("Contraband"));
};
let objDepartment = () => {
  return JSON.parse(localStorage.getItem("Department"));
};
let objDictCountry = () => {
  return JSON.parse(localStorage.getItem("DictCountry"));
};
let objRoleMapping = () => {
  return JSON.parse(localStorage.getItem("RoleMapping"));
};
let objTimezone = () => {
  return JSON.parse(localStorage.getItem("Timezone"));
};
let objLabel = () => {
  return JSON.parse(localStorage.getItem("Label"));
};
let objMethod = () => {
  return JSON.parse(localStorage.getItem("Method"));
};
let objAgent = () => {
  return JSON.parse(localStorage.getItem("Agent"));
};
let objParams = () => {
  return JSON.parse(localStorage.getItem("Params"));
};
let objTrackerStatus = () => {
  return JSON.parse(localStorage.getItem("TrackerStatus"));
};
let objWarehouse = () => {
  return JSON.parse(localStorage.getItem("Warehouse"));
};
let objFreight = () => {
  return JSON.parse(localStorage.getItem("Freight"));
};
let objAgentClear = () => {
  return JSON.parse(localStorage.getItem("agentClear"));
};
let objAgentDeliver = () => {
  return JSON.parse(localStorage.getItem("agentDeliver"));
};
let objCityGroup = () => {
  return JSON.parse(localStorage.getItem("CityGroup"));
};
let objClientGroup = () => {
  return JSON.parse(localStorage.getItem("ClientGroup"));
};
let objRole = () => {
  return JSON.parse(localStorage.getItem("role"));
};
let objDepAllObj = () => {
  return JSON.parse(localStorage.getItem("depAllObj"));
};

export default {
  objDictCity,
  objUserClient,
  objAccount,
  objDriverstatus,
  objCurrency,
  objException,
  objDictRole,
  objPackage,
  objAirport,
  objContraband,
  objDepartment,
  objDictCountry,
  objRoleMapping,
  objTimezone,
  objLabel,
  objMethod,
  objAgent,
  objParams,
  objTrackerStatus,
  objWarehouse,
  objFreight,
  objAgentClear,
  objAgentDeliver,
  objClientGroup,
  objCityGroup,
  objRole,
  objDepAllObj
};
